var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirtPlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.279,
    height: 31.176,
    viewBox: "0 0 27.279 31.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-alt",
    "data-name": "Icon awesome-calendar-alt",
    d: "M0,28.253a2.923,2.923,0,0,0,2.923,2.923H24.356a2.923,2.923,0,0,0,2.923-2.923V11.691H0ZM19.485,16.319a.733.733,0,0,1,.731-.731h2.436a.733.733,0,0,1,.731.731v2.436a.733.733,0,0,1-.731.731H20.216a.733.733,0,0,1-.731-.731Zm0,7.794a.733.733,0,0,1,.731-.731h2.436a.733.733,0,0,1,.731.731v2.436a.733.733,0,0,1-.731.731H20.216a.733.733,0,0,1-.731-.731Zm-7.794-7.794a.733.733,0,0,1,.731-.731h2.436a.733.733,0,0,1,.731.731v2.436a.733.733,0,0,1-.731.731H12.422a.733.733,0,0,1-.731-.731Zm0,7.794a.733.733,0,0,1,.731-.731h2.436a.733.733,0,0,1,.731.731v2.436a.733.733,0,0,1-.731.731H12.422a.733.733,0,0,1-.731-.731ZM3.9,16.319a.733.733,0,0,1,.731-.731H7.063a.733.733,0,0,1,.731.731v2.436a.733.733,0,0,1-.731.731H4.628a.733.733,0,0,1-.731-.731Zm0,7.794a.733.733,0,0,1,.731-.731H7.063a.733.733,0,0,1,.731.731v2.436a.733.733,0,0,1-.731.731H4.628a.733.733,0,0,1-.731-.731ZM24.356,3.9H21.433V.974A.977.977,0,0,0,20.459,0H18.511a.977.977,0,0,0-.974.974V3.9H9.742V.974A.977.977,0,0,0,8.768,0H6.82a.977.977,0,0,0-.974.974V3.9H2.923A2.923,2.923,0,0,0,0,6.82V9.742H27.279V6.82A2.923,2.923,0,0,0,24.356,3.9Z",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirtPlaceIcon);
export default __webpack_public_path__ + "static/media/BirtPlaceIcon.3ef96be98079ce9f24feab4423f6ecf3.svg";
export { ForwardRef as ReactComponent };